<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-2">
      <span class="fw-medium">
        <i class="fa-solid fa-cube text-secondary me-1" />
        {{ item.name }}
      </span>
      <button
        type="button"
        @click="$parent.deleteItemInput(index)"
        class="btn btn-sm btn-outline-danger"
        :title="$t('Delete')"
        style="--bs-btn-padding-y: .15rem; --bs-btn-padding-x: .4rem;"
      >
        <i class="fa-solid fa-trash" />
      </button>
    </div>
    <div class="row g-2">
      <div class="col-7 col-md-4">
        <label
          :for="'quantity'+index"
          class="form-label small text-secondary mb-1"
        >
          {{ $t('Quantity') }}
        </label>
        <div class="input-group input-group-sm">
          <input
            :id="'quantity'+index"
            type="number"
            inputmode="decimal"
            v-model.trim="v$.item.quantity.$model"
            class="form-control shadow-none"
            :placeholder="$t('Enter quantity') + '...'"
          >
          <span class="input-group-text">{{ $t(item.unit_name) }}</span>
        </div>
        <div v-for="error of v$.item.quantity.$errors"
          class="d-block invalid-feedback"
          :key="error.$uid"
        >
          {{ error.$message }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import { useVuelidate } from '@vuelidate/core';
import validation from "./assets/template/validation-input-item";
import numeral from 'numeral';
import Select2 from 'vue3-select2-component';

export default {
  setup: () => ({ v$: useVuelidate() }),
  validations() {
    return validation(this.item)
  },
  props: {
    item: {
      type: Object,
      default: [{
        inventory_id: '',
        name: '',
        unit_id: '',
        quantity: 0
      }]
    },
    index: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
    }
  },
  components: {
    Select2
  },
  methods: {
    async onSelectedUnit(e) {
      this.item.inventory_unit_id = e.inventory_unit_id;
      this.item.conversion_factor = e.conversion_factor;
    },
    formatNumber(value) {
      return numeral(value).format("0,0");
    },
    formatNumberTwoDigit(value) {
      return numeral(value).format("0,0.00");
    },
    formatNumberDigit(value) {
      return numeral(value).format("0,0.0000");
    },
  },
  async mounted() {},
  computed: {},
  watch: {}
}
</script>
